export default function getGapXSm(value) {
  switch (value) {
    case 0.5:
      return "sm:gap-x-0.5";
    case 1:
      return "sm:gap-x-1";
    case 2:
      return "sm:gap-x-2";
    case 3:
      return "sm:gap-x-3";
    case 4:
      return "sm:gap-x-4";
    case 5:
      return "sm:gap-x-5";
    case 6:
      return "sm:gap-x-6";
    case 7:
      return "sm:gap-x-7";
    case 8:
      return "sm:gap-x-8";
    case 9:
      return "sm:gap-x-9";
    case 10:
      return "sm:gap-x-10";
    case 12:
      return "sm:gap-x-12";
    case 14:
      return "sm:gap-x-14";
    case 16:
      return "sm:gap-x-16";
    case 20:
      return "sm:gap-x-20";
    case 24:
      return "sm:gap-x-24";
    case 28:
      return "sm:gap-x-28";
    case 32:
      return "sm:gap-x-32";
    case 36:
      return "sm:gap-x-36";
    case 40:
      return "sm:gap-x-40";
    case 44:
      return "sm:gap-x-44";
  }
}
